import PujaSubCategoriesView from "../../Views/Puja/PujaSubcategoriesView";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import ParentView from "../../Views/PrarentView/ParentView";
import { getTempleAndPujaList } from "../../store/actions/templeAction";
import { pageReady } from "../../store/slices/pageViewSlice";
import { getDeviceTypeFromUserAgent } from "../../utils/analyics/analyticsHelper";
import { LOCALSTORAGE_KEY } from "../../utils/Constants";
function PujaSubCategoriesScreen() {
  const location = useLocation();
  const dispatch: any = useDispatch();
  const navigate = useNavigate();
  const [filteredPujaList, setFilterEdPujaList]: any = useState([]);
  const [subCategoryDetails, setSubCategoryDetails]: any = useState([]);
  const { allPujaList } = useSelector((state: any) => state.temple);
  const { pujaMergedSubCategoryList } = useSelector((state: any) => state.puja);
  const subcategoryPujaId = location.pathname.split("/")[2];
  useEffect(() => {
    try {
      dispatch(getTempleAndPujaList());
    } catch (err: any) {}
  }, []);
  useEffect(() => {
    // dispatch(getPromotionalPujaListById(promotionalPujaId))
    if (allPujaList && allPujaList.length > 0) {
      getPujaForSubCategory(allPujaList, subcategoryPujaId);
    }

    if (pujaMergedSubCategoryList && pujaMergedSubCategoryList.length > 0) {
      let resFilter = pujaMergedSubCategoryList.filter(
        (item: any) => item.subCategoryId === subcategoryPujaId,
      );
      if (resFilter && resFilter.length > 0) {
        setSubCategoryDetails(resFilter[0]);
      }
    }
  }, [allPujaList, pujaMergedSubCategoryList]);

  useEffect(() => {
    const trackPageViewEvent = (filteredPujaList: any) => {
      if (!filteredPujaList) return;
      dispatch(
        pageReady({
          User_ID:
            JSON.parse(localStorage.getItem(LOCALSTORAGE_KEY.USERINFO) ?? "{}")
              ?.id ?? "Guest User",
          Page_Type: "Remedy SubCategory Listing",
          Listing_Type: "Remedy SubCategory",
          Total_Items_Shown: filteredPujaList?.length ?? 0,
          Device_Type: getDeviceTypeFromUserAgent(),
          Subcategory: subcategoryPujaId,
        }),
      );
    };

    trackPageViewEvent(filteredPujaList);
  }, [filteredPujaList,subcategoryPujaId]);

  function getPujaForSubCategory(allPujaList: any, subcategoryIncoming: any) {
    const activePujaList = allPujaList?.filter(
      (item: any) => !item?.pujaDetails?.isPujaDisable,
    );
    let finalData: any = [];
    for (let i = 0; i < activePujaList.length; i++) {
      let pujaDetails = activePujaList[i].pujaDetails;
      if (pujaDetails && pujaDetails.pujaSubCategory) {
        let subCategoryForPuja = pujaDetails.pujaSubCategory;
        let filterRes = subCategoryForPuja.filter(
          (item: any) => item.subCategoryId === subcategoryIncoming,
        );
        if (filterRes.length > 0) {
          finalData = [...finalData, activePujaList[i]];
        }
      }
    }

    setFilterEdPujaList(finalData);
  }

  const onClickParticipate = (pujaDetails: any) => {
    let pujaId = pujaDetails.pujaDetails.pujaId;
    let templeId = pujaDetails.id;
    navigate(`/temples/${templeId}/pujaInfo/${pujaId}`);
  };

  return (
    <ParentView>
      <PujaSubCategoriesView
        allPujaList={filteredPujaList}
        subCategoryDetails={subCategoryDetails}
        onClickAddPuja={onClickParticipate}
      />
    </ParentView>
  );
}

export default PujaSubCategoriesScreen;
